import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addProjectMaterialResource(
    request: Boundaries["addProjectMaterialResource"]["request"],
  ): void;
}

function useAddProjectMaterialResource(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddProjectMaterialResourceRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddProjectMaterialResourceRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddProjectMaterialResourceRequestFailure,
    ),
    addProjectMaterialResource: core.addProjectMaterialResource,
  };
}

export { useAddProjectMaterialResource };
